import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import Select from "react-select"
import AssignmentAction from "store/assignment-resource/actions"
import { getProductList } from "store/actions"
import ScrollBar from "react-perfect-scrollbar"
import StaffAction from "store/staff-resource/actions"
import { toast } from "react-toastify"
import Skeleton from "react-loading-skeleton"
import DateInput from "components/Common/DateInput"
import moment from "moment"

export default function ArrangementRTW() {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  const [filter, setFilter] = useState({
    weekId: "",
    weekName: "",
    companyName: "",
    scheduledDeliveryDateFrom: "",
    scheduledDeliveryDateTo: "",
    // type: 'RTW',
    productId: "",
    productName: "",
    size: "",
    finisherId: "",
    finisherName: "",
    staffId: "",
    staffName: "",
    scheduledDeliveryDateOrder: "ASC",
  })

  React.useEffect(() => {
    dispatch(AssignmentAction.getWeekList({}, callbackGetWeekList))
    dispatch(getProductList())
    dispatch(AssignmentAction.getRtwOrderSizeList())
    dispatch(AssignmentAction.getStaffTrouserList())
    dispatch(AssignmentAction.getStaffJacketList())
    dispatch(StaffAction.getList())
  }, [])

  const callbackGetWeekList = data => {
    const filtered = data.find(i => i.currentWeek)
    setFilter({
      ...filter,
      weekId: filtered.id,
      weekName: `${filtered.startDate} - ${filtered.endDate}`,
    })
    dispatch(
      AssignmentAction.getRtwOrderList({ ...filter, weekId: filtered.id })
    )
  }
  const callbackPut = data => {
    dispatch(
      AssignmentAction.putRTWDataLocal({
        ...data,
        weekId: filter.weekId,
      })
    )
    // dispatch(AssignmentAction.getRtwOrderList({ ...filter }))
    // dispatch(AssignmentAction.getStaffTrouserList())
    // dispatch(AssignmentAction.getStaffJacketList())
  }

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"手配"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col xl={3} md="6">
                <Label>作業期間</Label>
                <Select
                  isLoading={store.assignment.weekList.loading}
                  value={{
                    value: filter.weekId,
                    label: filter.weekName,
                  }}
                  options={store.assignment.weekList.data.map(i => ({
                    value: i.id,
                    label: `${i.startDate} - ${i.endDate}`,
                  }))}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        weekId: e.value,
                        weekName: e.label,
                      })
                      dispatch(
                        AssignmentAction.getRtwOrderList({
                          ...filter,
                          weekId: e.value,
                        })
                      )
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <TextInputWithLabel
                  label="顧客名"
                  placeholder={""}
                  value={filter.companyName}
                  type="text"
                  name="companyName"
                  onChange={onChangeFilter}
                />
              </Col>

              <Col md={6}>
                <Label>納品予定日</Label>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <DateInput
                    className="form-control"
                    value={filter.scheduledDeliveryDateFrom}
                    onChange={date => {
                      setFilter({
                        ...filter,
                        scheduledDeliveryDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setFilter({ ...filter, scheduledDeliveryDateFrom: "" })
                    }
                  />
                  <div>~</div>
                  <DateInput
                    className="form-control"
                    value={filter.scheduledDeliveryDateTo}
                    minDate={filter.scheduledDeliveryDateFrom}
                    onChange={date =>
                      setFilter({ ...filter, scheduledDeliveryDateTo: date[0] })
                    }
                    clear={() =>
                      setFilter({ ...filter, scheduledDeliveryDateTo: "" })
                    }
                  />
                </div>
              </Col>
              <Col md={3}>
                <Label>商品</Label>
                <Select
                  options={store.products.list.map(i => ({
                    value: i.id,
                    label: i.productName,
                  }))}
                  value={{
                    value: filter.productId,
                    label: filter.productName,
                  }}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        productId: e.value,
                        productName: e.label,
                      })
                    } else {
                      setFilter({
                        ...filter,
                        productId: "",
                        productName: "",
                      })
                    }
                  }}
                  isClearable
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <Label>サイズ</Label>
                <Select
                  isLoading={store.assignment.rtwOrderSize.loading}
                  options={store.assignment.rtwOrderSize.data.map(i => ({
                    value: i,
                    label: i,
                  }))}
                  value={{
                    value: filter.size,
                    label: filter.size,
                  }}
                  onChange={e => {
                    if (e) {
                      setFilter({ ...filter, size: e.value })
                    } else {
                      setFilter({ ...filter, size: "" })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col md={3}>
                <Label>仕上げ担当者</Label>
                <Select
                  isLoading={store.staff.list.loading}
                  options={store.staff.list.data.map(i => ({
                    value: i.id,
                    label: i.name,
                  }))}
                  value={{
                    value: filter.finisherId,
                    label: filter.finisherName,
                  }}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        finisherId: e.value,
                        finisherName: e.label,
                      })
                    } else {
                      setFilter({ ...filter, finisherId: "", finisherName: "" })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col md={6} className="text-end">
                <Label className="opacity-0">button</Label>
                <div>
                  <span>
                    <Button
                      className={`${
                        filter.scheduledDeliveryDateOrder == "DESC"
                          ? "button-active"
                          : "button"
                      }`}
                      disabled={filter.scheduledDeliveryDateOrder == "ASC"}
                      onClick={() => {
                        setFilter({
                          ...filter,
                          scheduledDeliveryDateOrder: "ASC",
                        })
                        dispatch(
                          AssignmentAction.getRtwOrderList({
                            ...filter,
                            scheduledDeliveryDateOrder: "ASC",
                          })
                        )
                      }}
                    >
                      昇順
                    </Button>
                    <Button
                      className={`ms-2 ${
                        filter.scheduledDeliveryDateOrder == "ASC"
                          ? "button-active"
                          : "button"
                      }`}
                      disabled={filter.scheduledDeliveryDateOrder == "DESC"}
                      onClick={() => {
                        setFilter({
                          ...filter,
                          scheduledDeliveryDateOrder: "DESC",
                        })
                        dispatch(
                          AssignmentAction.getRtwOrderList({
                            ...filter,
                            scheduledDeliveryDateOrder: "DESC",
                          })
                        )
                      }}
                    >
                      降順
                    </Button>
                  </span>

                  <SButton
                    className={"mx-2 button"}
                    onClick={() => {
                      const filtered = { ...filter }
                      filtered.scheduledDeliveryDateFrom =
                        filter.scheduledDeliveryDateFrom &&
                        moment(filter.scheduledDeliveryDateFrom).format(
                          "YYYY-MM-DD"
                        )
                      filtered.scheduledDeliveryDateTo =
                        filter.scheduledDeliveryDateTo &&
                        moment(filter.scheduledDeliveryDateTo).format(
                          "YYYY-MM-DD"
                        )
                      dispatch(
                        AssignmentAction.getRtwOrderList({ ...filtered })
                      )
                    }}
                  >
                    検索
                  </SButton>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Row>
          <Col lg="8">
            <ScrollBar style={{ height: 500 }}>
              <Row>
                {store.assignment.rtwOrder.loading ? (
                  // store.assignment.putRtwOrder.loading ||
                  // store.assignment.deleteRtwOrder.loading
                  <Skeleton count={5} />
                ) : (
                  store.assignment.rtwOrder.data.map((i, k) => {
                    return (
                      <Col lg="4" key={k}>
                        <Card
                          className={`${
                            i.assignedAlready
                              ? "bg-light-primary"
                              : "bg-light-warning"
                          }`}
                        >
                          <CardBody>
                            <Row>
                              <Col>
                                <div>{i.orderNumber}</div>
                                <div>{i.companyName}</div>
                                <div>{i.formType}</div>
                                <div>{i.rtwType}</div>
                                <div>サイズ　{i.size}</div>
                                <div>{i.scheduledDeliveryDate}</div>
                                <div>{i.fabricCompanyName}</div>
                                <div>{i.fabricBrand || "-"}</div>
                                <div>{i.fabricNumber}</div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="12" className="mt-2">
                                <Label>担当者</Label>
                                <br />
                                <Card>
                                  <CardBody
                                    style={{
                                      padding:
                                        i?.finisher?.length > 0
                                          ? "0px"
                                          : "12px",
                                    }}
                                  >
                                    <div
                                      className="d-flex flex-wrap gap-2 p-2"
                                      onDrop={e => {
                                        e?.preventDefault()
                                        let data =
                                          e.dataTransfer.getData("text")

                                        const parsed = JSON.parse(data)
                                        if (i?.finisher?.length >= 3) {
                                          toast.error(
                                            "仕上げ担当は３人までです。"
                                          )
                                          return
                                        }

                                        if (i.formType != parsed.title) {
                                          return toast.error(
                                            `職人種類をもう一度ご確認ください`
                                          )
                                        }
                                        dispatch(
                                          AssignmentAction.putRtwOrder(
                                            {
                                              weekId: filter.weekId,
                                              sequence: i?.finisher?.length
                                                ? i?.finisher?.length + 1
                                                : 1,
                                              finisherId: parsed.id,
                                              id: i.id,
                                            },
                                            callbackPut
                                          )
                                        )
                                      }}
                                      onDragOver={e => {
                                        e?.preventDefault()
                                      }}
                                    >
                                      {i?.finisher &&
                                        i?.finisher.map((j, l) => (
                                          <div
                                            draggable={j.deletable}
                                            className={`bg-info text-white py-1 px-2 rounded d-flex align-items-start justify-content-between`}
                                            key={l}
                                          >
                                            <div>{j.finisherName}</div>
                                            {j.deletable && (
                                              <Badge
                                                role="button"
                                                color="danger"
                                                className="ms-2"
                                                onClick={() => {
                                                  dispatch(
                                                    AssignmentAction.deleteRtwOrder(
                                                      {
                                                        weekId: filter.weekId,
                                                        sequence: j.sequence,
                                                        finisherId:
                                                          j.finisherId,
                                                        id: i.id,
                                                      },
                                                      callbackPut
                                                    )
                                                  )
                                                }}
                                              >
                                                x
                                              </Badge>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    )
                  })
                )}
              </Row>
            </ScrollBar>
          </Col>
          <Col lg="4" style={{ height: 250 }}>
            <Card>
              <ScrollBar style={{ height: 237 }}>
                <CardHeader>トラウザーズ担当者</CardHeader>
                <CardBody>
                  <div className="d-flex flex-wrap gap-2">
                    {store.assignment.staffListTrouser.loading ? (
                      <Skeleton count={5} />
                    ) : (
                      store.assignment.staffListTrouser.data.map((i, k) => (
                        <span
                          id={i.id}
                          title={i.form}
                          role="button"
                          className={`p-2 ${
                            filter.staffId == i.id
                              ? "bg-primary text-white"
                              : "bg-light"
                          }`}
                          key={k}
                          draggable
                          onDragStart={e => {
                            e.dataTransfer.setData(
                              "text",
                              JSON.stringify({
                                id: e.target.id,
                                title: e.target.title,
                              })
                            )
                          }}
                          onClick={() => {
                            if (filter.staffId == i.id) {
                              setFilter({
                                ...filter,
                                staffId: "",
                                staffName: "",
                              })
                              dispatch(
                                AssignmentAction.getRtwOrderList({
                                  ...filter,
                                  staffId: "",
                                })
                              )
                            } else {
                              setFilter({
                                ...filter,
                                staffId: i.id,
                                staffName: i.name,
                              })
                              dispatch(
                                AssignmentAction.getRtwOrderList({
                                  ...filter,
                                  staffId: i.id,
                                })
                              )
                            }
                          }}
                        >
                          <span className="me-3">{i.name}</span>
                          <Badge>{i.totalAssignment}</Badge>
                        </span>
                      ))
                    )}
                  </div>
                </CardBody>
              </ScrollBar>
            </Card>
            <Card>
              <ScrollBar style={{ height: 237 }}>
                <CardHeader>ジャケット担当者</CardHeader>

                <CardBody>
                  <div className="d-flex flex-wrap gap-2">
                    {store.assignment.staffListJacket.loading ? (
                      <Skeleton count={5} />
                    ) : (
                      store.assignment.staffListJacket.data.map((i, k) => (
                        <span
                          id={i.id}
                          title={i.form}
                          role="button"
                          className={`p-2 ${
                            filter.staffId == i.id
                              ? "bg-primary text-white"
                              : "bg-light"
                          }`}
                          key={k}
                          draggable
                          onDragStart={e => {
                            e.dataTransfer.setData(
                              "text",
                              JSON.stringify({
                                id: e.target.id,
                                title: e.target.title,
                              })
                            )
                          }}
                          onClick={() => {
                            if (filter.staffId == i.id) {
                              setFilter({
                                ...filter,
                                staffId: "",
                                staffName: "",
                              })
                              dispatch(
                                AssignmentAction.getRtwOrderList({
                                  ...filter,
                                  staffId: "",
                                })
                              )
                            } else {
                              setFilter({
                                ...filter,
                                staffId: i.id,
                                staffName: i.name,
                              })
                              dispatch(
                                AssignmentAction.getRtwOrderList({
                                  ...filter,
                                  staffId: i.id,
                                })
                              )
                            }
                          }}
                        >
                          <span className="me-3">{i.name}</span>
                          <Badge>{i.totalAssignment}</Badge>
                        </span>
                      ))
                    )}
                  </div>
                </CardBody>
              </ScrollBar>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
